<template lang="pug">
  div
    logoLoading(:status="logoLoadingStatus")
    v-app
      transition(enter-active-class="animated fadeIn" mode="out-in" appear)
        router-view

      // 狀態視窗
      v-dialog(:value="statusModal.status" persistent max-width="360px")
        v-card
          v-card-text
            v-layout.pt-4(justify-center align-center)
              v-icon.mr-2.align-start(color="achYellow2" style="font-size: 3rem") info
              div
                span.title(v-html="$t(statusModal.title)")
                p.subheading.achGray4--text.mt-1(style="margin: 0;font-size: 14px !important;" v-html="$t(statusModal.subTitle)")
          v-card-actions
            v-layout.my-3(justify-center)
              v-btn.white--text(color="achBlack" style="font-size: 18px;height: 48px;width: 45%;" round @click="submitStatusModal") 確定

      // 額度視窗
      v-dialog(:value="creditQuota.status" persistent max-width="470px")
        v-card
          v-card-title
            v-layout(align-start style="padding: 40px 30px 0;")
              v-icon(color="achYellow2" style="font-size: 36px;") error
              v-flex.pl-3
                v-layout(justify-start column)
                  span.title(v-html="creditQuota.title")
                  span.subtitle.achGray4--text.mt-2(v-html="creditQuota.subTitle")
          v-card-text.pt-0
            v-layout(justify-center align-center style="padding: 0 50px 0 82px;")
              span.subtitle.achGray4--text(v-html="creditQuota.desc")
          v-card-actions
            v-layout.my-3(justify-center)
              v-btn.white--text(color="achBlack" style="font-size: 18px;height: 48px;width: 45%;" round @click="submitCreditQuotaStatusModal") 確定
</template>

<script>
import logoLoading from 'components/loadings/logoLoading'

export default {
  name: 'App',
  components: {
    logoLoading
  },
  computed: {
    logoLoadingStatus () {
      return this.$store.getters.getLoadingStatus
    },
    statusModal () {
      return this.$store.getters.getModalInfoStatus
    },
    creditQuota () {
      let result = this.$store.getters.getCresitQuotaInfoStatus
      result['title'] = (result.type === 'over') ? this.$t('errors.quotaLimitOverError') : this.$t('errors.quotaLimitError')
      result['subTitle'] = (result.type === 'over') ? this.$t('errors.quotaLimitOverSubtitle') : this.$t('errors.quotaLimitErrorSubtitle', {msg: result.level})
      result['desc'] = this.$t('errors.quotaLimitDesc')
      return result
    }
  },
  methods: {
    submitStatusModal () {
      if (this.statusModal.btnLink) this.$router.push(this.statusModal.btnLink)
      this.$store.commit('SET_MODAL_STATUS', {status: false})
    },
    submitCreditQuotaStatusModal () {
      this.$store.commit('SET_QUOTA_MODAL_STATUS', {status: false})
    }
  }
}
</script>

<style lang="sass">
  body
    /*font-family: "PingFang SC", "Roboto", "Arial", "Noto Sans CJK TC", "Microsoft JhengHei" !important*/
    font-family: "PingFang SC", "Helvetica Neue",Helvetica,Arial,"Microsoft Yahei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif !important
    .application
      /*font-family: "PingFang SC", "Roboto", "Arial", "Noto Sans CJK TC", "Microsoft JhengHei" !important*/
      font-family: "PingFang SC", "Helvetica Neue",Helvetica,Arial,"Microsoft Yahei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif !important

  ::selection
    background-color: #ffc107
  *:focus
    outline-style: none
  // 覆寫 v-card style
  .custom-card
    min-width: 250px !important
    min-height: 190px
    box-shadow: none !important
    border: 1px solid #e8e8e8
  .v-pagination
    button
      box-shadow: none
      display: block  // for iphone safari
    .v-pagination__item
      width: auto
      min-width: 34px
      padding: 0 5px
  table
    tbody tr
      border-bottom: 1px solid #e8e8e8
  a:hover
    color: inherit !important
  .input-group.input-group--error label
    animation: shake .6s cubic-bezier(.25,.8,.5,1) !important
  @keyframes shake
    59%
      margin-left: 0
    60%, 80%
      margin-left: 2px
    70%, 90%
      margin-left: -2px

  /**** range date picker style ****/
  .daterangepicker
    .ranges
      li
        font-size: 1rem !important
      .active
        background-color: #feaa00 !important
        color: #000 !important
    .drp-calendar
      &.left, &.right
        .in-range
          background-color: rgba(254, 170, 0, 0.1) !important
        .start-date, .end-date
          background-color: #feaa00 !important
          color: #000 !important
    .calendar-table
      th, td
        font-size: 1rem !important
    select
      &.monthselect, &.yearselect
        font-size: 1rem !important
        width: inherit !important
  /**** range date picker style ****/

  .application .theme--light.btn.btn--disabled:not(.btn--icon):not(.btn--flat),
  .theme--light .btn.btn--disabled:not(.btn--icon):not(.btn--flat)
    cursor: not-allowed
    pointer-events: inherit
    background-color: transparent !important
  /* rewrite btn text style */
  .btn
    text-transform: none !important
  .application .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat),
  .theme--light .v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat)
    background-color: rgba(255, 255, 255, 0.5) !important

  /* 瀏覽器 自動填入 CSS */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active
    -webkit-box-shadow: 0 0 0px 1000px #fff inset /*淡淡的白*/

  #sideMenu
    min-height: 100% !important
  .v-btn
    .v-btn__content
      height: inherit
  .disabled
    color: rgba(0, 0, 0, .38)
    opacity: 0.5
</style>
